"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Nano_1 = require("../Nano");
const Lock_1 = __importDefault(require("./Lock"));
const utils_1 = require("../utils");
class Micro extends Nano_1.Nano {
    constructor(options = {}) {
        super(options);
        this.LOCK_AWAIT_STEP = 100;
        this.LOCK_AWAIT_LIMIT = 30 * 1000;
        this.options = super.options || options;
        if (this.options.LOCK_AWAIT_STEP) {
            this.LOCK_AWAIT_STEP = this.options.LOCK_AWAIT_STEP;
        }
        if (this.options.LOCK_AWAIT_LIMIT) {
            this.LOCK_AWAIT_LIMIT = this.options.LOCK_AWAIT_LIMIT;
        }
    }
    _expirationChecker() {
        const now = Date.now();
        super._forEach((element, key) => {
            if (typeof element === 'string' || element instanceof Lock_1.default) {
                return;
            }
            if (!element.options.noExpire && (!element.expireAt || element.expireAt < now)) {
                return this._expireKey(key, element);
            }
        });
    }
    async add(key, value, options = {}) {
        return super.add(key, value, options);
    }
    async set(key, value, options = {}) {
        return super.set(key, value, options);
    }
    async has(key) {
        if (!await this._has(key)) {
            return false;
        }
        const element = await this._get(key);
        if (Lock_1.default.isLock(element)) {
            return 'lock';
        }
        return true;
    }
    async get(key) {
        if (!await this._has(key)) {
            return undefined;
        }
        let element = await this._get(key);
        if (Lock_1.default.isLock(element)) {
            let LOCK_AWAIT_PASSED = 0;
            while (Lock_1.default.isLock(element = await this._get(key))) {
                await utils_1.wait(this.LOCK_AWAIT_STEP);
                LOCK_AWAIT_PASSED += this.LOCK_AWAIT_STEP;
                if (LOCK_AWAIT_PASSED >= this.LOCK_AWAIT_LIMIT) {
                    break;
                }
            }
            if (element === undefined) {
                return undefined;
            }
            if (Lock_1.default.isLock(element)) {
                this._delete(key);
                return undefined;
            }
        }
        const value = this._fromCacheElement(element);
        const options = element.options;
        const renewOnGet = options.renewOnGet !== undefined ? !!options.renewOnGet : !!this.options.renewOnGet;
        if (renewOnGet) {
            options.ttl = options.ttl || this.options.ttl || this.DEFAULT_TTL;
            this.set(key, value, options);
        }
        return value;
    }
    /**
     * Оборачивает переданную функцию в новую, позволяя сохранять
     * результат переданной функции в кэш с соответствующим ключём
     *
     * Возвращаемая функция принимает строковое значение с ключём в качестве первого аргумента
     * и передает это значение в переданную ранее функцию, так же первым аргументом
     *
     * Пример:
     * function myFunction(key, arg1, arg2) {}
     * const wrappedFunction = micro.wrapWithCache(myFunction)
     * wrappedFunction('unique-key', 1, 2)
     *
     * @param {Function} callback
     * @returns {Function}
     * @memberof Micro
     */
    wrapWithCache(callback, elementOptions = {}, wrapWithCacheOptions = {}) {
        const prefix = wrapWithCacheOptions.prefix || '';
        const cache = this;
        return async function (key, ...args) {
            const prefixedKey = prefix + key;
            const lock = new Lock_1.default();
            let result = await cache._add(prefixedKey, lock);
            if (Lock_1.default.isLock(result)) {
                if (!Lock_1.default.compareLocks(result, lock)) {
                    result = await cache.get(prefixedKey);
                }
                else {
                    result = undefined;
                }
                if (result === undefined) {
                    try {
                        result = await callback.call(this, key, ...args);
                        await cache.set(prefixedKey, result, elementOptions);
                    }
                    catch (error) {
                        await cache._delete(prefixedKey);
                        throw error;
                    }
                }
            }
            else {
                result = cache._fromCacheElement(result);
            }
            return result;
        };
    }
}
exports.Micro = Micro;
exports.default = Micro;
//# sourceMappingURL=index.js.map